import React from 'react';
import { Link } from 'react-router-dom';
import { AlertCircleIcon } from 'lucide-react';
import { Button } from '../components/ui/Button';

/**
 * Página 404 real.
 *
 * Antes cualquier ruta desconocida redirigía a la portada con
 * `<Navigate to="/" replace />`, lo que hacía que abrir una landing por su
 * enlace público (sistemaava.com/mi-slug) terminase siempre en la home.
 * Ahora una ruta que no existe se queda donde está y lo dice.
 */
export function NotFound() {
  return <main className="flex min-h-screen w-full flex-col items-center justify-center gap-4 bg-background px-6 text-center" data-id="element-2068" data-mp="1f2vmuw3hw6a9">
      <AlertCircleIcon className="h-10 w-10 text-muted-foreground" aria-hidden="true" data-id="element-2069" data-mp="1jtls89bx894y" />
      <h1 className="text-2xl font-semibold text-navy" data-id="element-2070" data-mp="1nvyugnrglowz">
        Esta página no existe
      </h1>
      <p className="max-w-md text-sm text-muted-foreground" data-id="element-2071" data-mp="1sv21ueuww784">
        El enlace que has abierto no corresponde a ninguna página publicada.
        Revisa la dirección o vuelve al inicio.
      </p>
      <Link to="/" data-id="element-2072" data-mp="1nvls6uyhkclf">
        <Button variant="secondary" data-id="element-2073" data-mp="1nwwxx0bhruf6">Volver al inicio</Button>
      </Link>
    </main>;
}